import React from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

import { DateHelper } from '../../../helpers/DateHelper';

import styles from './DatePickerInput.css';

const IPropTypes = {
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
};

const defaultProps = {
  fromDate: null,
  toDate: null,
  value: null,
  onChange: () => {},
};

const DATE_REGEXP = /^(\d\d?)\/(\d\d?)\/(\d{4})$/;

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${day}/${month}/${year}`;
};

const parseDate = (text) => {
  const trimmedText = (text || '').trim();
  const matches = DATE_REGEXP.exec(trimmedText);
  if (!matches) {
    return undefined;
  }
  const day = matches[1];
  const month = matches[2];
  const year = matches[3];
  return new Date(year, month - 1, day, 0, 0, 0, 0);
};

const getDayValidator = (fromDate, toDate) => (date) => {
  if (!fromDate && !toDate) {
    return false;
  }
  let dateValid = true;
  if (fromDate && date - fromDate < 0) {
    dateValid = false;
  }
  if (toDate && toDate - date < 0) {
    dateValid = false;
  }
  return !dateValid;
};

const getOnChangeCallback = (validator, callback) => (date) => {
  if (date && !validator(date)) {
    callback(date);
  }
};

const DatePickerInput = (props) => {
  const dayValidator = getDayValidator(props.fromDate, props.toDate);
  const dayPickerProps = {
    disabledDays: dayValidator,
    firstDayOfWeek: 1,
    locale: 'es',
    months: DateHelper.MONTHS,
    weekdaysLong: DateHelper.WEEKDAYS_LONG,
    weekdaysShort: DateHelper.WEEKDAYS_SHORT,
  };
  let startOfMonth = null;
  if (props.fromDate) {
    startOfMonth = new Date(
      props.fromDate.getFullYear(),
      props.fromDate.getMonth(),
    );
    dayPickerProps.fromMonth = startOfMonth;
  }
  if (props.toDate) {
    startOfMonth = new Date(
      props.toDate.getFullYear(),
      props.toDate.getMonth(),
    );
    dayPickerProps.toMonth = startOfMonth;
  }
  return (
    <DayPickerInput
      classNames={{
        container: styles.container,
        overlayWrapper: '',
        overlay: '',
      }}
      value={props.value}
      dayPickerProps={dayPickerProps}
      formatDate={formatDate}
      inputProps={{
        className: styles.input,
        readonly: 'readonly',
      }}
      onDayChange={getOnChangeCallback(dayValidator, props.onChange)}
      placeholder="DD/MM/AAAA"
      parseDate={parseDate}
    />
  );
};

DatePickerInput.propTypes = IPropTypes;
DatePickerInput.defaultProps = defaultProps;

export { DatePickerInput };



// WEBPACK FOOTER //
// ./src/common/installation-form/date-picker-input/DatePickerInput.jsx